import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { percent: { type: Number, default: 100 } };
  static targets = ['bar'];

  connect() {
    this.barTarget.style.width = '0%';

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.animate();
          this.observer.disconnect();
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  animate() {
    // Force le navigateur à rendre width: 0 avant d'appliquer la cible
    this.barTarget.getBoundingClientRect();
    this.barTarget.style.width = `${this.percentValue}%`;
  }
}
